var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "question-display" },
    [
      _c("div", { staticClass: "sr-only" }, [
        _c("p", [
          _vm._v(
            "\n\t\t\t\t\t\t\t" +
              _vm._s(
                _vm.$t("MAIN_CONTENT.testTaker.questionNumber", {
                  number: _vm.activeQuestion.SEQUENCE
                })
              ) +
              "\n\t\t\t\t\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pull-right" }, [
        _c("span", { staticClass: "pill pill-dark" }, [
          _vm._v(
            "\n\t\t\t\t\t\t\t" +
              _vm._s(
                _vm.$t("MAIN_CONTENT.MultipleChoiceQuestion.pointsPossible", {
                  points: _vm.activeQuestion.TOTAL_POINTS
                })
              ) +
              "\n\t\t\t\t\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "question-type-instructions" }, [
        _c("strong", [_vm._v(_vm._s(_vm.activeQuestion.QUESTION_NAME))]),
        _vm._v(" "),
        _vm.multipleAnswers
          ? _c("span", { staticClass: "hint" }, [
              _vm._v(
                "\n\t\t\t\t\t\t\t" +
                  _vm._s(
                    _vm.$t(
                      "MAIN_CONTENT.MultipleChoiceQuestion.selectAllMessage"
                    )
                  ) +
                  "\n\t\t\t\t\t\t"
              )
            ])
          : _c("span", { staticClass: "hint" }, [
              _vm._v(
                "\n\t\t\t\t\t\t\t" +
                  _vm._s(
                    _vm.$t(
                      "MAIN_CONTENT.MultipleChoiceQuestion.selectCorrectMessage"
                    )
                  ) +
                  "\n\t\t\t\t\t\t"
              )
            ]),
        _vm._v(" "),
        _vm.activeQuestion.ALLOW_NEGATIVE_TOTAL_POINTS_FLG
          ? _c("span", { staticClass: "hint" }, [
              _vm._v(
                "\n\t\t\t\t\t\t\t" +
                  _vm._s(
                    _vm.$t(
                      "MAIN_CONTENT.MultipleChoiceQuestion.incorrectMessage"
                    )
                  ) +
                  "\n\t\t\t\t\t\t"
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("h3", {
        staticClass: "question-text",
        domProps: { innerHTML: _vm._s(_vm.activeQuestion.QUESTION_TEXT) }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "answers" },
        _vm._l(_vm.activeQuestionAnswers, function(answer, index) {
          return _c(
            "div",
            {
              key: index,
              class: _vm.getAnswerClass(answer),
              attrs: { tabindex: "0" },
              on: {
                click: function($event) {
                  return _vm.answerTheQuestion(answer)
                },
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.answerTheQuestion(answer)
                }
              }
            },
            [
              _c(
                "div",
                {
                  class: ["answer-number", { selected: _vm.isSelected(answer) }]
                },
                [
                  _vm.answeredByStudent(answer)
                    ? _c("i", {
                        staticClass: "fa fas fa-arrow-circle-right",
                        attrs: {
                          "aria-label":
                            "Selected Answer " + _vm.getAnswerChoice(index),
                          "aria-live": "polite"
                        }
                      })
                    : _vm._e(),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.getAnswerChoice(index)) +
                      "\n                    "
                  ),
                  _vm.isGraded() && _vm.answeredByStudent(answer)
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "badge badge-dark answer-points float-right",
                          attrs: { "aria-label": "Points Earned" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t("MAIN_CONTENT.testTaker.points", {
                                  points: _vm.getPointsEarned(answer)
                                })
                              ) +
                              "\n                    "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "answer-text",
                domProps: { innerHTML: _vm._s(answer.ANSWER_TEXT) }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "grade-result" }, [
                _c("i", { class: _vm.getFeedbackIcon(answer) })
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("question-summary", { attrs: { answerData: _vm.answerData } }),
      _vm._v(" "),
      _vm.testMode !== "grading"
        ? _c("test-buttons", { on: { "answer-save": _vm.submitAnswer } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }